
import { Placement } from '@post-office/placements-frontend/admin-agent-recommendation';
export default Placement;
